import { z } from "zod";

/**
 * Newsletter subscription — name + e-mail, both required.
 *
 * Lives outside the component so the future BFF route can reuse it as its body
 * schema, keeping client and server validation from drifting.
 */
export const newsletterSubscribeSchema = z.object({
  name: z.string().trim().min(2, "Informe o seu nome."),
  email: z.string().trim().email("E-mail inválido."),
});

export type NewsletterSubscribeValues = z.infer<typeof newsletterSubscribeSchema>;
